import { Card, CardContent } from "@/components/ui/card";
import { Image, Video, Music, Wand2, Zap, Shield } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const FeaturesSection = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: Image,
      title: t("สร้างภาพ", "Photo Generation"),
      description: t("สร้างภาพสวยงามด้วยโมเดล GPT 1.5, Gemini Banana และ Seedream", "Create stunning images with GPT 1.5, Gemini Banana, and Seedream models."),
      color: "text-cyan-500",
      glow: "glow-primary",
    },
    {
      icon: Video,
      title: t("สร้างวิดีโอ", "Video Creation"),
      description: t("สร้างวิดีโอภาพยนตร์ด้วย Veo 3.1 และ Seedance 2.0 ในระยะเวลาต่างๆ", "Generate cinematic videos with Veo 3.1 and Seedance 2.0 at various durations."),
      color: "text-purple-500",
      glow: "glow-secondary",
    },
    {
      icon: Music,
      title: t("สร้างเพลง", "Music Synthesis"),
      description: t("แต่งเพลงต้นฉบับด้วยเทคโนโลยี Suno Music AI", "Compose original tracks with Suno Music AI technology."),
      color: "text-magenta-500",
      glow: "glow-accent",
    },
    {
      icon: Wand2,
      title: t("ตัวช่วยเขียน Prompt", "Prompt Generator"),
      description: t("AI ช่วยแนะนำ prompt เพื่อสร้างเนื้อหาที่ดีขึ้น", "AI-powered prompt suggestions to help you create better content."),
      color: "text-cyan-500",
      glow: "glow-primary",
    },
    {
      icon: Zap,
      title: t("เติมเครดิตทันที", "Instant Credits"),
      description: t("เติมเครดิตทันทีผ่าน QR code พร้อมตรวจสอบสลิป", "Add credits instantly via QR code payment with slip verification."),
      color: "text-purple-500",
      glow: "glow-secondary",
    },
    {
      icon: Shield,
      title: t("ปลอดภัยและรวดเร็ว", "Secure & Fast"),
      description: t("ความปลอดภัยระดับองค์กรพร้อมความเร็วในการสร้างที่รวดเร็ว", "Enterprise-grade security with lightning-fast generation speeds."),
      color: "text-magenta-500",
      glow: "glow-accent",
    },
  ];

  return (
    <section className="py-24 relative">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-4">
            {t("ฟีเจอร์", "Powerful")} <span className="text-gradient">{t("ทรงพลัง", "Features")}</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t("ทุกอย่างที่คุณต้องการเพื่อสร้างเนื้อหา AI ที่น่าทึ่งในแพลตฟอร์มเดียว", "Everything you need to create amazing AI-generated content in one platform.")}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <Card
              key={index}
              variant="glass"
              className="group hover:border-primary/30 transition-all duration-300 cursor-pointer"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="p-6">
                <div className={`w-14 h-14 rounded-xl bg-muted/50 flex items-center justify-center mb-4 group-hover:${feature.glow} transition-all duration-300`}>
                  <feature.icon className={`h-7 w-7 ${feature.color}`} />
                </div>
                <h3 className="text-xl font-heading font-semibold mb-2">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground">
                  {feature.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
